import { Routes } from '@angular/router';
import { ConsentComponent } from '@app/+profile-form/views/consent/consent.component';
import { NewProfileComponent } from '@app/+profile-form/views/new-profile/new-profile.component';
import { EditProfileComponent } from '@app/+profile-form/views/edit-profile/edit-profile.component';
import { SignupConfirmationComponent } from '@app/+profile-form/views/signup-confirmation/signup-confirmation.component';
import { UpdateConfirmationComponent } from '@app/+profile-form/views/update-confirmation/update-confirmation.component';
import { ProfileDestroyFinishComponent } from '@app/+profile-form/views/profile-destroy-finish/profile-destroy-finish.component';
import { DeleteProfileComponent } from '@app/+profile-form/views/delete-profile/delete-profile.component';
import { SignedInGuard } from '../core/guards/signed-in.guard';
import { ChangePasswordComponent } from '@app/+profile-form/views/change-password/change-password.component';
import { VerificationComponent } from '@app/+profile-form/views/verification/verification.component';
import { OpenMobileStoreGuard } from '@app/core/guards/open-mobile-store.guard';
import { ForcedUpdateComponent } from '@app/+profile-form/views/forced-update/forced-update.component';

export const FORCE_PROFILE_UPDATE_PATH = 'update';
export const UPDATE_CONFIRMATION_PATH = 'update_confirmation';
export const PROFILE_DESTROY_FINISH_PATH = 'cancel_confirmation';
export const NEW_PROFILE_PATH = 'new';
export const EDIT_PROFILE_PATH = 'edit';

export const PROFILE_ROUTES: Routes = [
  {
    path: '',
    redirectTo: EDIT_PROFILE_PATH,
    pathMatch: 'full',
  },
  { path: NEW_PROFILE_PATH, component: NewProfileComponent },
  { path: EDIT_PROFILE_PATH, canActivate: [OpenMobileStoreGuard, SignedInGuard], component: EditProfileComponent },
  {
    path: FORCE_PROFILE_UPDATE_PATH,
    canActivate: [OpenMobileStoreGuard, SignedInGuard],
    component: ForcedUpdateComponent,
  },
  { path: 'consents/:consentKey', canActivate: [OpenMobileStoreGuard, SignedInGuard], component: ConsentComponent },
  { path: 'change_password', canActivate: [SignedInGuard], component: ChangePasswordComponent },
  { path: 'delete', canActivate: [SignedInGuard], component: DeleteProfileComponent },
  { path: 'signup_confirmation', component: SignupConfirmationComponent },
  { path: UPDATE_CONFIRMATION_PATH, canActivate: [SignedInGuard], component: UpdateConfirmationComponent },
  {
    path: PROFILE_DESTROY_FINISH_PATH,
    component: ProfileDestroyFinishComponent,
  },
  { path: 'verification', component: VerificationComponent },
];
